import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";

const MenuButton = ({children, menuItems = [], onClick, ...otherProps}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (onClick) onClick(event);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Convert menuItems to MenuItem elements if they are plain objects (legacy react-md format)
  const renderMenuItems = () => {
    return menuItems.map((item, index) => {
      // If item is already a React element, render it as-is
      if (React.isValidElement(item)) {
        return item;
      }
      // If item is an object with onClick and primaryText (legacy react-md format), convert to MenuItem
      if (item && typeof item === 'object' && 'primaryText' in item) {
        return (
          <MenuItem key={index} onClick={item.onClick}>
            {item.primaryText}
          </MenuItem>
        );
      }
      // Otherwise, just return the item (could be a string or other renderable)
      return item;
    });
  };

  return (
    <div className={"MenuButton-Root"}>
      <Button
        id="dropdown-arrow" onClick={handleClick}
        endIcon={<Icon>arrow_drop_down</Icon>}
        {...otherProps}
      >
        {children}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {renderMenuItems()}
      </Menu>
    </div>
  );
};

MenuButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  menuItems: PropTypes.array,
  onClick: PropTypes.func,
};

export default MenuButton;